import _regeneratorRuntime from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { getAreas } from '@/api/yunyingAdmin';
import { invokeApi, scanExcludeEmptyChildren } from '@/utils/shared';
import { reactive, ref } from 'vue';
export default {
  __name: 'index',
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var selectDom = ref();
    var data = reactive({
      opts: []
    });
    init();
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return invokeApi(getAreas, {});
            case 2:
              res = _context.sent;
              data.opts = scanExcludeEmptyChildren(res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _init.apply(this, arguments);
    }
    function changeArea(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        provinceCode = _ref2[0],
        cityCode = _ref2[1],
        areaCode = _ref2[2];
      var _selectDom$value$getC = selectDom.value.getCheckedNodes()[0].pathNodes.map(function (it) {
          return it.label;
        }),
        _selectDom$value$getC2 = _slicedToArray(_selectDom$value$getC, 3),
        provinceName = _selectDom$value$getC2[0],
        cityName = _selectDom$value$getC2[1],
        areaName = _selectDom$value$getC2[2];
      Object.assign(props.model, {
        provinceCode: provinceCode,
        cityCode: cityCode,
        areaCode: areaCode,
        provinceName: provinceName,
        cityName: cityName,
        areaName: areaName
      });
    }
    return {
      __sfc: true,
      props: props,
      selectDom: selectDom,
      data: data,
      init: init,
      changeArea: changeArea
    };
  }
};